import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  width: 100%;

  form {
    display: block;
    width: 100%;
  }

  .form-line {
    display: flex;
    gap: 10px;
    align-items: flex-start;
    width: 100%;
  }

  .comment-field {
    flex: 1 1 auto;
    min-width: 0;
  }

  .comment-field textarea {
    height: 50px;
    min-height: 50px;
    padding-top: 10px;
    padding-bottom: 10px;
  }

  button {
    width: 130px;
    float: right;
    margin-top: 10px;
  }
`;
